import { IMenuItemConfig } from '@core/js/components/system/App/store/types';

export const deepFind = ({ items, childrenKey, sourceKey, source }
    : { items: IMenuItemConfig[]; childrenKey: string; sourceKey: string; source: string }): IMenuItemConfig | undefined => {
    let result: any = null;
    let item: any = null;

    if (!Array.isArray(items)) {
        return;
    }

    for (let i: number = 0, len: number = items.length; i < len; i++) {
        item = items[i];

        if (item[sourceKey] === source) {
            return item;
        }

        if (item[childrenKey]) {
            result = deepFind({
                items: item[childrenKey],
                childrenKey,
                sourceKey,
                source
            });
        }

        if (result) {
            return result;
        }
    }
};

export const transformStrToArray = (str: string, separators?: string[]) => {
    if (!str) {
        return [];
    }

    const separator = separators
        ? separators.find(separatorItem => str.includes(separatorItem)) || ','
        : ',';

    return str
        .split(separator)
        .map(item => item.trim())
        .filter(Boolean);
};

export const fromArrayToObject = <T extends Record<string, any>, K extends keyof T>({
    data = [],
    key
}: {
    data: T[];
    key: K;
}): Record<T[K], T> => {
    return data.reduce((acc, item) => {
        acc[item[key]] = item;

        return acc;
    }, {} as Record<T[K], T>);
};

export const prepareTranslateKey = (key: string): string => key?.replace(/[^a-zA-Z]+/g, '_')
    .trim()
    .toLowerCase();
